import { EditableCard } from "../../../components/editableCard.component";
import { PatientList } from "../../patient/patientList.component";
import { AppRouteUi } from "../../../config/appRoute";
import { ApiSchemaCaregiver } from "../../../models/api";

type Props = {
  data: ApiSchemaCaregiver | undefined;
  isValidating: boolean;
};

export const CaregiverPatientList = (props: Props) => {
  return (
    <EditableCard
      link={`${AppRouteUi.Caregiver.Root()}/update/${props.data?.sKey}`}
      title="Patient List"
      isValidating={props.isValidating}
    >
      <PatientList
        data={props.data?.patients ?? []}
        isValidating={props.isValidating}
        isInProfile
      />
    </EditableCard>
  );
};
